import React, { useState, useEffect } from "react";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import LoadProfile from "../UtilityComponents/loadProfile";
// import test from "../Utilities/test";
import brand from "../Assets/techforce_logo.png";
import "./navbar.css";
import CustomModal from "../UtilityComponents/customModal";
import TermsandConditions from "./TermsandConditions.js";
import { getNotifications } from "../Redux/actions/notifications";
import EllipsisWithTooltip from "react-ellipsis-with-tooltip";
import {downloadStudio} from "../Redux/actions/workers";
import { updateProfile } from "../Redux/actions/user/";


const profileDropdownStyle = {
  position: "absolute",
  willChange: "transform",
  top: "0px",
  left: "0px",
  transform: "translate3d(-250px, 60px, 0px)",
  width: "300px",
  height: "210px",
};

const DemoDropdownStyle = {
  position: "absolute",
  willChange: "transform",
  top: "0px",
  left: "100px",
  transform: "translate3d(-250px, 60px, 0px)",
  width: "200px",
  height: "120px",
};


const notificationDropdownStyle = {
  position: "absolute",
  willChange: "transform",
  top: "0px",
  left: "0px",
  transform: "translate3d(-250px, 60px, 0px)",
  width: "310px",
  height: "500px",
  overflow: "auto",
};

function NavBar(props) {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [notificationDropdownOpen, setNotificationDropdownOpen] = useState(
    false
  );
  const [demoDropdownOpen, setDemoDropdownOpen] = useState(
    false
  );
  const [modal, setModal] = useState(false);
  const [alertModal,setAlertModal] = useState(true)
  const [notificationList, setNotificationList] = useState([]);
  const [notificationDot, setNotificationDot] = useState("far fa-bell");

  const profileToggle = () => setDropdownOpen((prevState) => !prevState);

  const notificationsToggle = () => {
    setNotificationDot("far fa-bell");
    setNotificationDropdownOpen((prevState) => !prevState);
  };

  const demoToggle = () => {
    setDemoDropdownOpen((prevState) => !prevState);
  };

  const toggle = () => setModal(!modal);

  const handleLogout = async(e) => {
    e.preventDefault();
    localStorage.clear();
    props.history.push("/");
    props.logout();
  };

  const handleRoute = (e) => {
    e.preventDefault();
    props.history.push("/settings");
  };

  const alertToggle = (e) => {
    setAlertModal(!alertModal);
  }

  const download = async () => {
    let {downloadURL} = await  downloadStudio()
        let a = document.createElement("a");
        a.href = downloadURL;
        a.click();
  };

  const showToggle = () => {
    return(
      <div className="notification-alert">
        <div class="alert alert-danger">
          <strong>Please Note:</strong> EM Console is under going a scheduled maintenance upgrade between 2020-9-30 16:01:58 to 2020-9-30 16:01:58.
          <i  className="fa" style={{position: "absolute",bottom: 46,top:"3px"}} onClick={alertToggle}>&#xf00d;</i>
        </div>
      </div>
    )
  }
  
  useEffect(() => {
    const fetchData = async (msg) => {
      let data = await getNotifications();
      if (data) {
        setNotificationList(data);
      }
    };
    fetchData();
  }, []);

  window.EventEmitter.on("notification", async (msg) => {
    if (msg) {
      let data = await getNotifications();
      if (data) {
        setNotificationList(data);
        setNotificationDot("far fa-bell notification");
      }
    }
  });

  let { user } = props;
  let name =
    user.given_name && user.family_name
      ? user.given_name.charAt(0).toUpperCase() +
        user.family_name.charAt(0).toUpperCase()
      : "";
  return (
    <div>
      <nav className="nav-container">
        <div className="company-brand">
          <a href="/">
            <img src={brand} alt="logo.png" width="600" height="20"/>
          </a>
        </div>

        {/* {alertModal?showToggle():""} */}

        <div className="icons-container"  >
          <div className="download">
            {/* <a  href="https://tfai-studio.s3.amazonaws.com/techforce.ai-studio-install-v1.0.1-alpha.11.zip">
              <button className="btn">Download Studio </button>
            </a>   */}
            <button className="btn" onClick={download}>
              Download Studio{" "}
            </button>
          </div>
          <Dropdown
            isOpen={notificationDropdownOpen}
            toggle={notificationsToggle}
          >
            <DropdownToggle className="profile-btn">
              <i className={notificationDot}></i>
            </DropdownToggle>
            <DropdownMenu
              style={notificationDropdownStyle}
              className="notification-dropdown  text-center pt-5"
            >
              {notificationList && notificationList.length != 0 ? (
                notificationList.map((obj, index) => {
                  let { message, created_at } = obj;
                  let msgTime = new Date(
                    new Date(created_at).toDateString()
                  ).getTime();
                  let currnetTime = new Date(
                    new Date().toDateString()
                  ).getTime();
                  let displyOption =
                    msgTime === currnetTime
                      ? new Date(created_at).toLocaleTimeString()
                      : new Date(created_at).toDateString();
                  return (
                    <div className="notification-body-view" key={index}>
                      <span className="message">{message}</span>
                      <div className="footer">
                        <span className="date"> {displyOption}</span>
                        {/* <span className="close">close</span> */}
                      </div>
                    </div>
                  );
                })
              ) : (
                <div>
                  <div className="no-notifications text-center">
                    <i className="far fa-bell"></i>
                  </div>
                  <p>No Notifications</p>
                </div>
              )}
            </DropdownMenu>
          </Dropdown>

          <Dropdown isOpen={demoDropdownOpen} toggle={demoToggle}>
            <DropdownToggle className="i-btn">
              <i className="fa fa-info-circle" style={{fontSize:"1.5rem"}}></i>
            </DropdownToggle>
            <DropdownMenu 
              style={DemoDropdownStyle}
              className="i-dropdown"
             >
              <DropdownItem className="demo-dropdown">
                                  <a  href="https://digitamizers.github.io/Documentation/index.html" className ="demo-dropdownText" target="_blank" >
                                    Documentation
                                  </a>
              </DropdownItem>
              <DropdownItem className="demo-dropdown">
                <a  href="https://www.youtube.com/playlist?list=PL968gLCD1WCGkamH6jGiPpX5Pi3J1WnuR" target="_blank" className ="demo-dropdownText">
                  Video Walkthroughs
                </a>
              </DropdownItem>
            </DropdownMenu>
          </Dropdown>

          <Dropdown isOpen={dropdownOpen} toggle={profileToggle}>
            <DropdownToggle className="profile-btn">
              {user.profilePic || name.length === 0 ? (
                <LoadProfile {...props.user} />
              ) : (
                <div
                  className="navicon navicon-1 "
                  style={{ padding: "5px !important" }}
                >
                  {name}
                </div>
              )}{" "}
            </DropdownToggle>
            <DropdownMenu
              style={profileDropdownStyle}
              className="profile-dropdown"
            >
              <DropdownItem header>
                <div className="profile-section">
                  {user.profilePic || name.length === 0 ? (
                    <LoadProfile {...props.user} />
                  ) : (
                    <div className="navicon">{name}</div>
                  )}
                  <div className="user-name user-info">
                    {user.name ? (
                      user.name.length > 25 ? (
                        <EllipsisWithTooltip placement="bottom">
                          {user.name}
                        </EllipsisWithTooltip>
                      ) : (
                        <div>{user.name}</div>
                      )
                    ) : (
                      ""
                    )}
                    <span>{user.email}</span>
                  </div>
                </div>
              </DropdownItem>
              <DropdownItem divider />
              <DropdownItem onClick={toggle}>Terms and Conditions</DropdownItem>
              <DropdownItem onClick={handleRoute}>Settings</DropdownItem>
              <DropdownItem onClick={handleLogout}>Logout</DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </div>
        
            {modal ? (
              <CustomModal
                style={{ width: "1000px" }}
                comp={<TermsandConditions toggle={() => toggle()} />}
                name="Terms and Conditions"
                toggle={() => toggle()}
                modal={modal}
              />
            ) : null}
      </nav>
      {modal ? (
        <CustomModal
          style={{ width: "1000px" }}
          comp={<TermsandConditions toggle={() => toggle()} />}
          name="Terms and Conditions"
          toggle={() => toggle()}
          modal={modal}
        />
      ) : null}
    </div>
  );
}

export default NavBar;
